import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React from 'react'
import closeIcon from '../../assets/images/icon-close-alert.png'
import './index.scss'



const ConfirmationPopup = ({
	displayPopUp,
	setDisplayPopUp,
	header,
	message,
	primaryBtnLbl,
	acceptFn,
	secondaryBtnLbl,
	headerText,
}) => {
	const closeDialog = () => {
		setDisplayPopUp(false);
	};

	const handleConfirmation = () => {
		closeDialog();
		acceptFn();
	};

	// footer for the Dialog
	const modalFooter = (
		<div className="flex-column flex-lg-row delete-cancel-btn-container">
			<button
				id="cancelButton"
				className="secondary-button cancel-button order-2 order-lg-1"
				type="button"
				onClick={closeDialog}
			>
				{secondaryBtnLbl}
			</button>

			<button
				id="confirmButton"
				className="primary-button delete-button order-1 order-lg-2"
				type="button"
				onClick={handleConfirmation}
			>
				{primaryBtnLbl}
			</button>
		</div>
	);

	// custom close icon
	const customClose = (
		<i>
			<img src={closeIcon} alt="close" title="close" onClick={closeDialog} />
		</i>
	);

	return (
		<Dialog
			visible={displayPopUp}
			closable={false}
			modal
			header={headerText || header}
			footer={modalFooter}
			className="confirmation-dialog-error modal-dialog"
			onHide={closeDialog}
		>
			<div className="delete-confirm-msg-row">
				<div className="delete-confirm-msg">{message}</div>
			</div>
		</Dialog>
	);
};

export default ConfirmationPopup;

